'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var requestId = 1;

var Search = function (_React$Component) {
	_inherits(Search, _React$Component);

	function Search(props) {
		_classCallCheck(this, Search);

		var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

		_this.state = {
			open: false,
			searchInput: '',
			results: _this.emptyResults(),
			resultsTerm: null,
			selected: 0
		};

		_this.handleInputChange = _this.handleInputChange.bind(_this);
		_this.handleOpen = _this.handleOpen.bind(_this);
		_this.handleClose = _this.handleClose.bind(_this);
		_this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
		_this.handleSearch = (0, _lodash.throttle)(_this.handleSearch.bind(_this), 100, { trailing: true, leading: false });
		_this.renderResults = _this.renderResults.bind(_this);
		_this.renderBrands = _this.renderBrands.bind(_this);
		_this.renderStores = _this.renderStores.bind(_this);
		_this.renderContacts = _this.renderContacts.bind(_this);
		_this.renderBudgets = _this.renderBudgets.bind(_this);
		_this.renderOrders = _this.renderOrders.bind(_this);
		_this.selectPrevious = _this.selectPrevious.bind(_this);
		_this.selectNext = _this.selectNext.bind(_this);
		_this.toggleQuickSearchKey = _this.toggleQuickSearchKey.bind(_this);

		document.addEventListener("keydown", _this.toggleQuickSearchKey);
		return _this;
	}

	_createClass(Search, [{
		key: 'startListening',
		value: function startListening() {
			document.addEventListener("keydown", this.handleInputKeyDown);
		}
	}, {
		key: 'stopListening',
		value: function stopListening() {
			document.removeEventListener("keydown", this.handleInputKeyDown);
		}
	}, {
		key: 'emptyResults',
		value: function emptyResults() {
			return {
				brands: [],
				stores: [],
				contacts: [],
				reports: [],
				budgets: [],
				orders: []
			};
		}
	}, {
		key: 'toggleQuickSearchKey',
		value: function toggleQuickSearchKey(e) {
			// if(e.keyCode === 84) { // t
			if (e.keyCode === 81) {
				// q
				if (e.target.matches('input') || e.target.matches('textarea')) {
					console.log('used in text area');
				} else {
					e.preventDefault();
					this.inputElement.focus();
					this.handleOpen();
					return false;
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var open = this.state.open;


			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("site-search", { open: open }) },
				_react2.default.createElement(
					'div',
					{ className: 'search-box' },
					_react2.default.createElement('i', { className: 'ri-search' }),
					_react2.default.createElement('input', { type: 'text',
						ref: function ref(e) {
							_this2.inputElement = e;
						},
						value: this.state.searchInput,
						onClick: this.handleOpen,
						onChange: this.handleInputChange,
						placeholder: 'Search'
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'search-results' },
					_react2.default.createElement(
						'div',
						{ className: 'nav' },
						_react2.default.createElement('i', { className: 'ri-cross',
							onClick: this.handleClose
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'search-results-wrapper' },
						this.renderResults()
					),
					_react2.default.createElement(
						'div',
						{ className: 'info' },
						'Use ',
						_react2.default.createElement(
							'kbd',
							null,
							'\u2191'
						),
						' and ',
						_react2.default.createElement(
							'kbd',
							null,
							'\u2193'
						),
						' to navigate, ',
						_react2.default.createElement(
							'kbd',
							null,
							'enter'
						),
						' to go to pages, ',
						_react2.default.createElement(
							'kbd',
							null,
							'esc'
						),
						' to exit.'
					)
				)
			);
		}
	}, {
		key: 'renderResults',
		value: function renderResults() {

			if (this.state.searchInput.length < 1) {
				return _react2.default.createElement(
					'div',
					{ className: 'search-intro' },
					'Start typing your query to begin search...'
				);
			}

			return _react2.default.createElement(
				'div',
				{ className: 'results' },
				this.renderBrands(),
				this.renderStores(),
				this.renderContacts(),
				this.renderReports(),
				this.renderBudgets(),
				this.renderOrders()
			);
		}
	}, {
		key: 'renderBrands',
		value: function renderBrands() {
			var _this3 = this;

			if (!this.state.results.brands || !this.state.results.brands.length) return;

			var selectedDelta = 0;

			return _react2.default.createElement(
				'div',
				{ className: 'block' },
				_react2.default.createElement(
					'div',
					{ className: 'block-title' },
					'Brands'
				),
				_react2.default.createElement(
					'div',
					{ className: 'block-results' },
					this.state.results.brands.map(function (brand, i) {
						return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("result result-brand", { selected: _this3.state.selected - selectedDelta == i + 1 }), key: brand.id },
							_react2.default.createElement(
								'a',
								{ href: "/directory/brands/" + brand.slug },
								brand.name
							)
						);
					})
				)
			);
		}
	}, {
		key: 'renderStores',
		value: function renderStores() {
			var _this4 = this;

			if (!this.state.results.stores || !this.state.results.stores.length) return;

			var selectedDelta = this.state.results.brands.length;

			return _react2.default.createElement(
				'div',
				{ className: 'block' },
				_react2.default.createElement(
					'div',
					{ className: 'block-title' },
					'Stores'
				),
				_react2.default.createElement(
					'div',
					{ className: 'block-results' },
					this.state.results.stores.map(function (store, i) {
						return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("result result-store", { selected: _this4.state.selected - selectedDelta == i + 1 }), key: store.id },
							_react2.default.createElement(
								'a',
								{ href: "/directory/stores/" + store.slug },
								store.name
							),
							' ',
							_this4.storeRegisteredName(store.registered_name)
						);
					})
				)
			);
		}
	}, {
		key: 'renderContacts',
		value: function renderContacts() {
			var _this5 = this;

			if (!this.state.results.contacts || !this.state.results.contacts.length) return;

			var selectedDelta = this.state.results.stores.length + this.state.results.brands.length;

			return _react2.default.createElement(
				'div',
				{ className: 'block' },
				_react2.default.createElement(
					'div',
					{ className: 'block-title' },
					'Contacts'
				),
				_react2.default.createElement(
					'div',
					{ className: 'block-results' },
					this.state.results.contacts.map(function (contact, i) {
						return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("result result-contact", { selected: _this5.state.selected - selectedDelta == i + 1 }), key: contact.id },
							_react2.default.createElement(
								'a',
								{ href: "/directory/contacts/" + contact.slug },
								contact.first_name,
								' ',
								contact.last_name
							),
							'  \u2013 ',
							_this5.contactBrand(contact)
						);
					})
				)
			);
		}
	}, {
		key: 'renderReports',
		value: function renderReports() {
			var _this6 = this;

			if (!this.state.results.reports || !this.state.results.reports.length) return;

			var selectedDelta = this.state.results.stores.length + this.state.results.brands.length + this.state.results.contacts.length;

			return _react2.default.createElement(
				'div',
				{ className: 'block' },
				_react2.default.createElement(
					'div',
					{ className: 'block-title' },
					'Reports'
				),
				_react2.default.createElement(
					'div',
					{ className: 'block-results' },
					this.state.results.reports.map(function (report, i) {
						return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("result result-report", { selected: _this6.state.selected - selectedDelta == i + 1 }), key: report.id },
							_react2.default.createElement(
								'a',
								{ href: "/reports/" + report.slug },
								report.title
							)
						);
					})
				)
			);
		}
	}, {
		key: 'renderBudgets',
		value: function renderBudgets() {
			var _this7 = this;

			if (!this.state.results.budgets || !this.state.results.budgets.length) return;

			var selectedDelta = this.state.results.stores.length + this.state.results.brands.length + this.state.results.contacts.length + this.state.results.reports.length;

			return _react2.default.createElement(
				'div',
				{ className: 'block' },
				_react2.default.createElement(
					'div',
					{ className: 'block-title' },
					'Budgets'
				),
				_react2.default.createElement(
					'div',
					{ className: 'block-results' },
					this.state.results.budgets.map(function (item, i) {
						return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("result result-budget", { selected: _this7.state.selected - selectedDelta == i + 1 }), key: item.id },
							_react2.default.createElement(
								'a',
								{ href: "/data/budgets/" + item.id },
								item.name
							)
						);
					})
				)
			);
		}
	}, {
		key: 'renderOrders',
		value: function renderOrders() {
			var _this8 = this;

			if (!this.state.results.orders || !this.state.results.orders.length) return;

			var selectedDelta = this.state.results.stores.length + this.state.results.brands.length + this.state.results.contacts.length + this.state.results.reports.length + this.state.results.budgets.length;

			return _react2.default.createElement(
				'div',
				{ className: 'block' },
				_react2.default.createElement(
					'div',
					{ className: 'block-title' },
					'Orders'
				),
				_react2.default.createElement(
					'div',
					{ className: 'block-results' },
					this.state.results.orders.map(function (item, i) {
						return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("result result-order", { selected: _this8.state.selected - selectedDelta == i + 1 }), key: item.id },
							_react2.default.createElement(
								'a',
								{ href: "/data/orders/" + item.id },
								item.id,
								' \u2013 ',
								item.brand.name,
								' \u2013 ',
								item.store.name
							)
						);
					})
				)
			);
		}
	}, {
		key: 'contactBrand',
		value: function contactBrand(contact) {
			return contact[contact.company_type] ? contact[contact.company_type].name : '--';
		}
	}, {
		key: 'storeRegisteredName',
		value: function storeRegisteredName(registeredName) {
			return registeredName ? '(' + registeredName + ')' : '';
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(e) {
			var _this9 = this;

			var term = e.target.value;
			this.setState({
				searchInput: term
			}, function () {
				_this9.handleSearch(term);
			});
		}
	}, {
		key: 'handleInputKeyDown',
		value: function handleInputKeyDown(e) {
			if (e.keyCode == 13) {
				this.goToCurrentlySelected();
				e.preventDefault();
				return false;
			}
			if (e.keyCode == 40) {
				this.selectNext();
				e.preventDefault();
				return false;
			}
			if (e.keyCode == 38) {
				this.selectPrevious();
				e.preventDefault();
				return false;
			}
			if (e.keyCode == 27) {
				this.handleClose();
				e.preventDefault();
				return false;
			}
		}
	}, {
		key: 'selectPrevious',
		value: function selectPrevious() {
			var _this10 = this;

			this.setState({
				selected: Math.max(0, this.state.selected - 1)
			}, function () {
				_this10.shouldItScroll();
			});
		}
	}, {
		key: 'selectNext',
		value: function selectNext() {
			var _this11 = this;

			var _state$results = this.state.results,
			    brands = _state$results.brands,
			    stores = _state$results.stores,
			    contacts = _state$results.contacts,
			    reports = _state$results.reports,
			    budgets = _state$results.budgets;

			var total = brands.length + stores.length + contacts.length + reports.length + budgets.length;

			this.setState({
				selected: Math.min(total, this.state.selected + 1)
			}, function () {
				_this11.shouldItScroll();
			});
		}
	}, {
		key: 'handleSearch',
		value: function handleSearch(term) {
			var _this12 = this;

			if (term.length < 1) {
				this.setState({
					results: this.emptyResults()
				});
				return;
			}

			requestId++;
			var currentRequestId = requestId;

			_request2.default.get({
				url: location.origin + '/ajax/search?q=' + encodeURIComponent(term.trim())
			}, function (err, res, body) {
				if (err) {
					console.log(err);
					return;
				}

				// If there has been a new request made, then ignore the results of this request. 	
				if (currentRequestId !== requestId) {
					return;
				}

				_this12.setState({
					results: JSON.parse(body),
					resultsTerm: term
				});
			});
		}
	}, {
		key: 'handleOpen',
		value: function handleOpen() {
			if (this.state.open == true) return;

			document.body.classList.add("search-open");
			this.startListening();
			this.setState({
				open: true
			});
		}
	}, {
		key: 'handleClose',
		value: function handleClose() {
			document.activeElement.blur();
			document.body.classList.remove("search-open");
			this.stopListening();
			this.setState({
				open: false,
				searchInput: ''
			});
		}
	}, {
		key: 'goToCurrentlySelected',
		value: function goToCurrentlySelected() {
			if (selected == 0) return;

			var selected = this.state.selected - 1;
			var _state$results2 = this.state.results,
			    brands = _state$results2.brands,
			    stores = _state$results2.stores,
			    contacts = _state$results2.contacts,
			    reports = _state$results2.reports,
			    budgets = _state$results2.budgets;


			if (selected < brands.length) {
				window.location = '/directory/brands/' + brands[selected].slug;
			}
			selected -= brands.length;
			if (selected < stores.length) {
				window.location = '/directory/stores/' + stores[selected].slug;
			}
			selected -= stores.length;
			if (selected < contacts.length) {
				window.location = '/directory/contacts/' + contacts[selected].slug;
			}
			selected -= contacts.length;
			if (selected < reports.length) {
				window.location = '/reports/' + reports[selected].slug;
			}
			selected -= reports.length;
			if (selected < budgets.length) {
				window.location = '/data/budgets/' + budgets[selected].id;
			}
		}
	}, {
		key: 'shouldItScroll',
		value: function shouldItScroll() {
			var element = document.querySelector('.search-results .selected');
			if (!element) return;
			var elementOffset = element.offsetTop;

			var searchWindow = document.querySelector('.search-results');
			var windowHeight = searchWindow.offsetHeight;
			var windowScrollTop = searchWindow.scrollTop;

			if (elementOffset > windowScrollTop + windowHeight - 200) {
				// if element is below visible window

				searchWindow.scrollTop = elementOffset - windowHeight + 200;
			} else if (elementOffset < windowScrollTop + 150) {
				// if element is above visible window

				searchWindow.scrollTop = elementOffset - 150;
			}
		}
	}]);

	return Search;
}(_react2.default.Component);

exports.default = Search;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/search/Search.js
// module id = 521
// module chunks = 0